import { render, staticRenderFns } from "./FormInfo.vue?vue&type=template&id=5566c63e&scoped=true&"
import script from "./FormInfo.vue?vue&type=script&lang=js&"
export * from "./FormInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormInfo.vue?vue&type=style&index=0&id=5566c63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5566c63e",
  null
  
)

export default component.exports